import Styleguide from "@store/Framework/Types/Styleguide";

const addressBook: Styleguide["addressBook"] = {};

export default addressBook;
